// noinspection JSUnresolvedFunction

/**
 * init Google Maps for Partner search
 */
window.initMap = function () {
    const startLat = 48.364090;
    const startLng = 10.909200;

    const normalPin = MP_PATH + 'assets/img/maxxis-pin-icon.svg';
    const premiumPin = MP_PATH + 'assets/img/maxxis-pin-icon-premium.svg';

    const markerSize = {
        width: 48,
        height: 48,
    };

    const premiumMarkerSize = {
      width: 48,
      height: 69,
    };

    const initZoom = 13;
    const zoomAfterSearch = 13;

    $.ajax({
        url: MP_PATH + 'ajax/helper/ajax.getPartner.php',
        success: function (jsonData) {
            // Create the map
            const map = new google.maps.Map(document.getElementById('map'), {
                zoom: initZoom,
                center: {
                    lat: startLat,
                    lng: startLng
                },
            });

            // Load the stores GeoJSON onto the map
            map.data.addGeoJson(jsonData, {
                idPropertyName: 'storeid'
            });

            map.data.setStyle(function(feature) {
              return {
                icon: {
                  url: feature.getProperty('isPreminum') ? premiumPin : normalPin ,
                  scaledSize: feature.getProperty('isPreminum') ? (new google.maps.Size(premiumMarkerSize.width, premiumMarkerSize.height)) : (new google.maps.Size(markerSize.width, markerSize.height))
                }
              };
            });

            // Load default store-list
            let prepareStoreList = [];
            $.each(jsonData.features, function (key, value) {
                prepareStoreList.push(value.properties.storeid);
            });

            // Show the information for a store when its marker is clicked
            const infoWindow = new google.maps.InfoWindow();
            map.data.addListener('click', (event) => {
                // Properties
                const name = event.feature.getProperty('name');
                const street = event.feature.getProperty('street');
                const city = event.feature.getProperty('city');
                const phone = event.feature.getProperty('phone');
                const email = event.feature.getProperty('email');
                const web = event.feature.getProperty('web');

                // Position
                const position = event.feature.getGeometry().get();

                // Template
                let templateDetail = $('#haendler-detail').html();
                const replaces = {
                    '$NAME': name,
                    '$STREET': street,
                    '$CITY': city,
                    '$PHONE':  `<a href="tel:${phone}">${phone}</a>`,
                    '$EMAIL':  `<a href="mailto:${email}">${email}</a>`,
                    '$WEB': `<a href="https://${web.replace('https://', '')}" target="_blank">${web}</a>`,
                };
                $.each(replaces, function (k, v) {
                    templateDetail = templateDetail.replace(k, v);
                });

                // Set content and position
                infoWindow.setContent(templateDetail);
                infoWindow.setPosition(position);
                infoWindow.setOptions({
                    pixelOffset: new google.maps.Size(0, -30),
                });
                infoWindow.open(map);
            });

            // Build and add the search bar
            const options = {
                types: ['geocode'],
                componentRestrictions: {
                    country: 'de'
                },
            };
            const cityInput = document.getElementById('input-city');
            cityInput.addEventListener('keydown', (event) => {

              if ($('#noSearchResult').length > 0) {
              } else {
                $('.locationsearch .form-field').append('<small id="noSearchResult" class="error-message">Ort oder Postleitzahl nicht gefunden</small>');
              }
            })

            // Make the search bar into a Places Autocomplete search bar and select which detail fields should be returned about the place that the user selects from the suggestions
            const autocomplete = new google.maps.places.Autocomplete(selectFirstOnEnter(cityInput), options);
            autocomplete.setFields([
                'address_components', 'geometry', 'name'
            ]);

            // Set the origin point when the user selects an address
            const originMarker = new google.maps.Marker({
                map: map
            });
            originMarker.setVisible(false);

            let originLocation = map.getCenter();
            autocomplete.addListener('place_changed', async () => {
                originMarker.setVisible(false);
                originLocation = map.getCenter();
                const place = autocomplete.getPlace();

                const errorMessages = $('#error-messages');
                errorMessages.hide();
                if (!place.geometry) {
                    // User entered the name of a Place that was not suggested and pressed the Enter key, or the Place Details request failed
                    errorMessages.show().html(LANG_STRINGS.KEINE_KORREKTE_ADRESSE_EINGEGEBEN + ': ' + place.name);
                    return;
                }
                const addressComponents = place.address_components;
                const cityComponent = addressComponents.find(component => component.types.includes('locality') || component.types.includes('administrative_area_level_1'));
                const zipCodeComponent = addressComponents.find(component => component.types.includes('postal_code'));
                const city = cityComponent ? cityComponent.long_name : null;
                const zipCode = zipCodeComponent ? zipCodeComponent.long_name : null;

                // Recenter the map to the selected address
                originLocation = place.geometry.location;
                map.setCenter(originLocation);
                map.setZoom(zoomAfterSearch);

                originMarker.setPosition(originLocation);
                originMarker.setVisible(true);
                showStoresList(map.data, prepareStoreList);
            });

            /**
             * build StoreList
             * @param data
             * @param stores
             */
            window.showStoresList = function (data, stores) {
                const listStores = $('#list-stores');
                $('#noSearchResult').remove();
                listStores.hide();
                listStores.html('');

                const errorMessages = $('#error-messages');
                errorMessages.hide();
                if (stores.length === 0) {
                    errorMessages.show().html(LANG_STRINGS.KEINE_HAENDLER_IM_BEREICH_GEFUNDEN);
                } else {
                    stores.forEach((store) => {
                        // Current Store
                        const storeID = (typeof store.storeid !== 'undefined' ? store.storeid : store);
                        const currentStore = data.getFeatureById(storeID);

                        // Properties
                        const name = currentStore.getProperty('name');
                        const id = currentStore.getProperty('storeid');
                        // Template
                        let templateList = $('#haendler-list').html();
                        const replaces = {
                            '$ID': id,
                            '$NAME': name,
                            '$DISTANCE': (typeof store.distanceText !== 'undefined' ? store.distanceText : ''),
                        };
                        $.each(replaces, function (k, v) {
                            templateList = templateList.replace(k, v);
                        });

                        // Append to list
                        listStores.append(templateList);
                    });
                }

                $.ajax({
                url: MP_PATH + 'ajax/helper/ajax.calculateDistance.php',
                type: 'post',
                data: {
                  /*shops: jsonDataSmall,*/
                  getLat: originLocation.lat(),
                  getLng: originLocation.lng(),
                },
                success: function (response) {
                  //showStoresList(map.data, response);
                  for (const r of response) {
                    const listItemSpan = document.querySelector(`#list-stores li[data-id="${r.storeid}"]  span.distance`);
                    if(listItemSpan && r?.distanceVal) {
                      listItemSpan.innerHTML = `${Math.ceil(parseFloat(r.distanceVal))} km`
                    }
                  }
                  sortStoresByDistance();
                }
              });
            };

            /**
             * shoow Popup Box by click
             * @param link
             */
            window.showPopupbox = function (link) {
                const popupID = link.getAttribute('data-id');
                const marker = map.data.getFeatureById(popupID);

                google.maps.event.trigger(map.data, 'click', {
                    feature: marker
                });
            };

            // build Initiale Storelist
            showStoresList(map.data, prepareStoreList);
        }
    });
};

/**
 * Modify a HTML input to select the first suggested location
 * @param input
 * @returns {*}
 */
function selectFirstOnEnter(input) {
  const originalAddEventListener = input.addEventListener;
  let hasPressedDownArrow = false;

  /**
   * Wrapper funcion for addEventListener
   * add overriding logic to addEventListener of the given input
   * @param eventType
   * @param eventListener
   */
  function addEventListenerWrapper(eventType, eventListener) {
    // Overwrite 'keydown' event
    if (eventType === "keydown") {
      const givenEventHandler = eventListener;
      eventListener = function (event) {
        // Check for 'Enter' key press without prior 'Down Arrow' key press
        if (event.which === 13 && !hasPressedDownArrow) {
          simulateKeyDown(40);
        } else if (event.which === 40) {
          hasPressedDownArrow = true;
        }

        // Reset focus and flag if 'Enter' key is pressed
        if (event.which === 13) {
          input.blur();
          hasPressedDownArrow = false;
        }

        // add the original handler
        // if the key Enter was pressed, we have already simulated the down arrow button press (simulateKeyDown)
        // by the time we fire the "Enter" event, the first item is already selected
        givenEventHandler.apply(input, [event]);
      };
    }

    // Call the original addEventListener with the modified listener
    originalAddEventListener.apply(input, [eventType, eventListener]);
  }

  /**
   * Function to simulate keydown event
   * @param keyCode
   */
  function simulateKeyDown(keyCode) {
    const keyEvent = document.createEvent("Events");
    keyEvent.initEvent("keydown", true, true);
    keyEvent.which = keyCode;
    keyEvent.keyCode = keyCode;
    input.dispatchEvent(keyEvent);
  }

  // Replace the original addEventListener with the wrapper
  input.addEventListener = addEventListenerWrapper;
  return input;
}

/**
 * Sort by distance
 * Filter when too far
 */
function sortStoresByDistance() {
  const list = document.getElementById('list-stores');
  let items = Array.from(list.getElementsByTagName('li'));
  const extractDistance = (str) => {
    var match = str.match(/([\d.]+) km/);
    return match ? parseFloat(match[1]) : 0;
  }

  items.sort(function(a, b) {
    const distanceA = extractDistance(a.querySelector('.distance').textContent);
    const distanceB = extractDistance(b.querySelector('.distance').textContent);
    return distanceA - distanceB;
  });

  items = items.filter(function(el, idx) {
    const distance = extractDistance(el.querySelector('.distance').textContent);
    return distance < 61;
  });

  while (list.firstChild) {
    list.removeChild(list.firstChild);
  }

  items.forEach(function(item) {
    list.appendChild(item);
  });
  $('#list-stores').show();
}